// Content admin portal routes.
export const CONTENT_ROUTE_LOGIN = '/content/login';
